export const USER_DETAIL_COLUMN = [
    { headerName: 'Emergency', dataName: 'emergency', bodyElement: { value: 'isEmergencyState', dataType: 'boolean' }, enable: true},
	{ headerName: 'Packet Sequence', dataName: 'packetSequence', bodyElement: { value: 'packetSequence', dataType: 'float' }, enable: true},
	{ headerName: 'Watch Check-In', dataName: 'watchCheckIn', bodyElement: { value: 'checkInTime', dataType: 'created' }, enable: true},
	{ headerName: 'Received Check-In', dataName: 'receviedCheckIn', bodyElement: { value: 'createdAt', dataType: 'created' }, enable: true},
	{ headerName: 'GPS', dataName: 'gps', bodyElement: { value: 'latLong' }, enable: true},
	{ headerName: 'Heart Rate', dataName: 'heartRate', bodyElement: { value: 'heartRate', concatString: ' bpm' }, enable: true},
	{ headerName: 'Signal', dataName: 'signal', bodyElement: { value: ['signalStrength', 'networkType'], dataType: 'signal' }, enable: true},
	{ headerName: 'Battery Status', dataName: 'batteryStatus', bodyElement: { value: 'batteryStatus', dataType: 'percent' }, enable: true},
	{ headerName: 'Charging', dataName: 'charging', bodyElement: { value: 'isCharging', dataType: 'boolean' }, enable: true},
	{ headerName: 'On Wrist', dataName: 'onWrist', bodyElement: { value: 'isOnWrist', dataType: 'boolean' }, enable: false},
]

export const USER_COLUMN_ORDER = {
	'emergency': 1, 
	'packetSequence': 2, 
	'watchCheckIn': 3,
	'receviedCheckIn': 4,
	'gps': 5,
	'heartRate': 6,
	'signal': 7,
	'batteryStatus': 8,
	'charging': 9,
	'onWrist': 10
}

export const USER_COLUMN_NAME = [
	{name: "Emergency", value:"emergency"},
	{name: "Packet Sequence", value:"packetSequence"},
	{name: "Watch Check-In", value:"watchCheckIn"},
	{name: "Received Check-In", value:"receviedCheckIn"},
	{name: "GPS", value:"gps"},
	{name: "Heart Rate", value:"heartRate"},
	{name: "Signal", value:"signal"},
	{name: "Battery Status", value:"batteryStatus"},
	{name: "Charging", value:"charging"},
	{name: "On Wrist", value:"onWrist"}
]
